import graphql from "babel-plugin-relay/macro";
import styled from "styled-components";
import { useFragment } from "react-relay";
import { FieldDetailsLabelsFragment$key } from "./__generated__/FieldDetailsLabelsFragment.graphql";
import { DetailsContainer, DetailText } from "./FieldDetails";

interface Props {
  fieldData: FieldDetailsLabelsFragment$key;
}

const FieldDetailsLabels = ({ fieldData }: Props) => {
  const field = useFragment(
    graphql`
      fragment FieldDetailsLabelsFragment on FieldNode {
        labels {
          edges {
            node {
              id
              text
            }
          }
        }
      }
    `,
    fieldData
  );
  return (
    <FieldDetailsContainer>
      <DetailsContainer>
        <DetailGrid>
          {field?.labels?.edges?.length ? (
            field?.labels?.edges?.map((edge) => (
              <Label key={edge?.node?.id} title={edge?.node?.text}>
                {edge?.node?.text}
              </Label>
            ))
          ) : (
            <DetailText>Er zijn geen labels gekoppeld</DetailText>
          )}
        </DetailGrid>
      </DetailsContainer>
    </FieldDetailsContainer>
  );
};

const FieldDetailsContainer = styled.div`
  margin: 20px 0;
`;

const DetailGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 2px;
`;

const Label = styled.span`
  background-color: #f1f1f1;
  border-radius: 8px;
  padding: 4px 8px;
  margin-right: 8px;
  overflow: hidden;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export default FieldDetailsLabels;
